<template>
  <div class="header">
    <div class="inner clearfix">
      <div class="logo-box clearfix">
        <span class="logo-pic">
          <img
            src="//img-i.gcimg.net/2018/1219/fspfd35uex1a6k4k085832.png"
            width="32"
            height="32"
          >
        </span>
        <div class="logo-txt">
          <!-- {{ $t('message["1381"]') }} -->
          {{ (isProject || isManage) ? comName : '星轨' }}
        </div>
      </div>
      <div class="org-head-nav">
        <div class="org-head-menu">
          <template v-if="(isProject || isManage)">
            <template v-if="$store.state.isManage">
              <router-link
                :to="{ name: 'ProjectIndexPc', query: {...$route.query} }"
                :exact="false"
                :class="{ 'router-link-active': isProject }"
              >
                项目
              </router-link>
              <router-link
                :to="{name: 'OrgPerson', query: {...$route.query}}"
                :class="{ 'router-link-active': !isProject }"
                :exact="false"
              >
                <!-- {{ $t('message["365"]') }} -->
                管理
              </router-link>
            </template>
          </template>
          <template v-else>
            <router-link
              :to="{ name: 'OrgLayout' }"
              :exact="false"
              :class="{ 'router-link-active': !isAccountInfo }"
            >
              <!-- {{ $t('message["1678"]') }} -->
              我的组织
            </router-link>
            <router-link
              :to="{name: 'AccountInfo'}"
              :class="{ 'router-link-active': isAccountInfo }"
              :exact="false"
            >
              {{ $t('message["365"]') }}
            </router-link>
          </template>
        </div>
      </div>
      <div class="org-right clearfix">
        <!-- <i
          class="icon-new-year"
          @click="showSpringDialog"
        /> -->
        <i
          v-if="isNewFeature"
          class="new-feature-icon iconfont iconnew1"
          @click="getNewCon"
        />
        <header-dropdown />
      </div>
    </div>
    <new-feature-dialog ref="newFeatureTip" />
    <!-- <spring-dialog ref="springModal" /> -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import HeaderDropdown from './HeaderDropdown'
import NewFeatureDialog from './NewFeatureDialog'
// import Cookies from 'js-cookie'
// import SpringDialog from './SpringTipDialog'
export default {
  components: {
    HeaderDropdown,
    NewFeatureDialog
  },
  data () {
    return {
      cookie: ''
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    ...mapState('newFeature', ['newFeatureInfo']),
    ...mapState('organization/org', ['comName']),
    isNewFeature () {
      return this.baseinfo.announce
    },
    routerName () {
      return this.$route.name
    },
    isAccountInfo () {
      return this.routerName === 'AccountInfo' || this.routerName === 'AccountLoginLog' || this.routerName === 'AccountOrder' || this.routerName === 'AccountInvoice' || this.routerName === 'AccountMailList'
    },
    isProject () {
      const $pageName = this.$route.name
      return $pageName === 'ProjectIndexPc'
    },
    isManage () {
      const $pageName = this.$route.name
      return $pageName === 'OrgPerson' || $pageName === 'OrgInvite' || $pageName === 'OrgCloud' || $pageName === 'OrgQw' || $pageName === 'OrgProjects'
    },
    baseInfo () {
      const { baseinfo = {} } = this.$store.state
      return baseinfo
    }
  },
  mounted () {
    // this.cookie = Cookies.get('old')
    // if (!this.cookie) {
    //   this.$refs.springModal.changeLimitDialog(true)
    //   Cookies.set('old', this.$store.state.auth, { expires: 30 })
    // }
  },
  methods: {
    ...mapActions('newFeature', ['getNewFeatureInfo']),
    async getNewCon () {
      const { newFeatureInfo } = this
      if (!newFeatureInfo) {
        const chain = await this.getNewFeatureInfo()
        chain.onSuccess(raw => {
          this.$refs.newFeatureTip.changeLimitDialog(true)
        })
      } else {
        this.$refs.newFeatureTip.changeLimitDialog(true)
      }
    }
    // showSpringDialog () {
    //   this.$refs.springModal.changeLimitDialog(true)
    // }
  }
}
</script>

<style lang="scss" scoped>
.header {
  height: 56px;
  line-height: 56px;
  background-color: #fff;
  border-bottom: solid 1px $gray4;
  .inner {
    max-width: 1280px;
    margin: 0 auto;
    position: relative;
  }
  .org-head-menu {
    display: inline-block;

    a {
      display: inline-block;
      color: #333;
      height: 54px;
      line-height: 54px;
      font-size: 18px;
      margin: 0 16px;
      box-sizing: content-box;
    }

    .router-link-active, a:hover {
      font-weight: 600;
      color: #5077aa;
      border-bottom: 2px solid #5077aa;
    }
  }
  .org-head-nav {
    position: absolute;
    text-align: center;
    left: 0;
    top: 0;
    right: 0;
}

.logo-box {
  float: left;
  height: 32px;
  line-height: 32px;
  padding: 12px 0;
  box-sizing: content-box;

  .logo-txt {
    float: left;
    line-height: 32px;
    font-size: 18px;
    color: #333;
    font-weight: 500;
  }

  .logo-pic {
    float: left;
    width: 32px;
    height: 32px;
    margin-right: 10px;

    img {
      width: 32px;
      height: 32px;
    }
  }
}
  .message {
    width: 32px;
    height: 32px;
    line-height: 32px;
    margin: 12px 24px 12px 0;
    text-align: center;
    background-color: #f7f7f7;
    border-radius: 16px;
    cursor: pointer;
    .message-icon {
      font-size: 18px;
      color: $gray2;
    }
  }
  .arrow-icon {
    margin-left: 7px;
    color: #ccc;
  }
}
.org-right {
  position: absolute;
  right: 0;
  top: 0;
  .h-new-rance {
    float: left;
      .icontiaoyan {
      color: #1296db;
      font-size: 20px;
      vertical-align: middle;
      margin-right: 4px;
    }
    a {
      color: #666;
    }
  }
  .ant-dropdown-link {
    float: right
  }
  .new-feature-icon {
    float: left;
    color: #4CA0F2;
    font-size: 32px;
    margin-right: 12px;
    cursor: pointer;
  }
  // .icon-new-year {
  //   width: 32px;
  //   height: 32px;
  //   background:url(../../assets/images/newyearico.png) no-repeat 0 0;
  //   background-size: 32px 32px;
  //   float: left;
  //   margin-right: 12px;
  //   vertical-align: middle;
  //   margin-top: 12px;
  //   cursor: pointer;
  // }
}
</style>
